import { withStyles } from '@material-ui/core';

import SelectRow from './component';
import styles from './styles';

export default withStyles(styles)(SelectRow);
